import header from "./baufinanzierung-living-space-table.webp";
import section1 from "./grundriss-fuer-baufinanzierung.jpg";
import section2 from "./baufinanzierung-bank-plan.jpg";
import section3 from "./comparing-floor-plan.jpg";
import section4 from "./baufinanzierung.jpg";
import section5 from "./calculating-building-loan.jpg";
import section6 from "./construction-site-by-abandoned-building-against-sky.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
